import {categoriesActionRoute} from '@netx/core-category-next/actions/categories-route';
import {searchesSavedActionRoute} from '@netx/core-search-saved/actions/searches-saved-route';
import {cartsSavedActionRoute} from '@netx/core-cart-saved/actions/carts-saved-route';
import {uploadAssetActionRoute} from '@netx/core-upload-asset/actions/upload-asset-route';
import {assetExpirationActionListRoute} from '@netx/core-asset-expiration/actions/asset-expiration-list-route';
import {dataSetActionDataSetsManageRoute} from '@netx/core-data-set/actions/data-sets-manage-route';
import {downloadRequestActionRequestsManageRoute} from '@netx/core-download-request/actions/download-requests-manage-route';
import {projectReviewActionReviewsRoute} from '@netx/core-project-review/actions/project-reviews-route';
import {shareLinkActionLinksRoute} from '@netx/core-share-link/actions/share-links-route';
import {statsActionStatsRoute} from '@netx/core-stat-next/actions/stats-route';
import {uploadAssetRequestActionRequestsManageRoute} from '@netx/core-upload-asset-request-manager/actions/upload-asset-requests-manage-route';
import {attributeUploadActionRoute} from '@netx/core-attribute-upload/actions/attributes-upload-route';
import {uploadCartCurrentUploadAction} from '@netx/core-cart-current-upload/actions/cart-current-upload-route';
import {systemActionRoute} from '@netx/core-system-next/actions/system-route';
import {userActionHelp} from '@netx/core-user-next/actions/user-help';
import {
	userActionLogout,
	userActionProfile,
	userActionSettings,
} from '@netx/core-user-next/actions';
import {
	createMenuStore,
	useMenu,
} from '@netx/core-app-next/store/menuItemsBase';
import {appActionHomeRoute} from '../actions/app-home-route';
import {AppCombinedMenuItemsSection} from '../constants';

export const useAppCombinedMenuStore = createMenuStore();

export const useAppCombinedMenu = () =>
	useMenu({store: useAppCombinedMenuStore});

useAppCombinedMenuStore
	.getState()
	.addMenuItems(
		[
			appActionHomeRoute(),
			uploadAssetActionRoute(),
			categoriesActionRoute(),
			searchesSavedActionRoute(),
			cartsSavedActionRoute(),
		],
		{section: AppCombinedMenuItemsSection.MAIN},
	);

useAppCombinedMenuStore
	.getState()
	.addMenuItems(
		[
			downloadRequestActionRequestsManageRoute(),
			uploadAssetRequestActionRequestsManageRoute(),
			attributeUploadActionRoute(),
			dataSetActionDataSetsManageRoute(),
			assetExpirationActionListRoute(),
			shareLinkActionLinksRoute(),
			projectReviewActionReviewsRoute(),
			uploadCartCurrentUploadAction(),
			statsActionStatsRoute(),
		],
		{section: AppCombinedMenuItemsSection.TOOLS},
	);

useAppCombinedMenuStore.getState().addMenuItems([systemActionRoute()], {
	section: AppCombinedMenuItemsSection.SYSTEM,
});

useAppCombinedMenuStore
	.getState()
	.addMenuItems(
		[
			userActionProfile({order: 0}),
			userActionSettings({order: 2}),
			userActionHelp(),
		],
		{
			section: AppCombinedMenuItemsSection.USER,
		},
	);

useAppCombinedMenuStore.getState().addMenuItems([userActionLogout()], {
	section: AppCombinedMenuItemsSection.SIGN_OUT,
});
